import type { MessagesTranslations } from "../../types/messages";

export const messages: MessagesTranslations = {
  title: "Sõnumitahvel",
  composerPlaceholder: "Kirjuta sõnum…",
  send: "Saada",
  sendFailed: "Sõnumit ei õnnestunud saata. See on tagasi väljas — proovi uuesti.",
  reply: "Vasta",
  replyingTo: "Vastad kasutajale {name}",
  cancelReply: "Tühista vastamine",
  edit: "Muuda",
  delete: "Kustuta",
  edited: "Muudetud",
  deletedNote: "Kustutatud sõnum",
  deletedQuote: "Sõnum pole saadaval",
  today: "Täna",
  yesterday: "Eile",
  emptyChannel: "Sõnumeid veel pole — alusta vestlust.",
  noProjects: "Projekte veel pole",
  noProjectsHint: "Sõnumite saatmiseks loo sellele hoonele projekt.",
  attach: "Lisa fail",
  mention: "Maini kedagi",
  addReaction: "Lisa reaktsioon",
  expand: "Laienda",
  confirmDelete: "Kas kustutada see sõnum?",
  confirmDeleteDescription: "See sõnum eemaldatakse kõigi jaoks. Seda ei saa tagasi võtta.",
  channelsHeading: "Projektid",
  selectChannel: "Vali projekti kanal",
  unreadBadge: "{count} uut",
};
